import { render, staticRenderFns } from "./listChatItem.vue?vue&type=template&id=0a292c3e&scoped=true&"
import script from "./listChatItem.vue?vue&type=script&lang=js&"
export * from "./listChatItem.vue?vue&type=script&lang=js&"
import style0 from "./listChatItem.vue?vue&type=style&index=0&id=0a292c3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a292c3e",
  null
  
)

export default component.exports